import React from 'react';

const CardWalletCurrency = ({ balance = "$ 3,000,000.32", label = "Balance total", conversion, icon }) => {
  return (
    <div className="w-full h-full flex flex-col py-6 px-6 bg-[#1a1b22] rounded-xl gap-6 ">
      <div className='flex flex-row gap-2' >
        {icon && <img src={icon} className='h-4 w-4' alt="" />}
        <p className='text-[#B7B7B9] text-base font-bold leading-5 traking-[-0.16px] ' >{label}</p>
      </div>
      <div className='flex flex-col ' >
        <h2 className='text-[#fff] text-[28px] font-normal leading-5 traking-[-0.56px] pb-3 '  > {balance} </h2>
        <p className='text-[#B7B7B9] text-base font-normal leading-5 traking-[-0.16px] '>{conversion}</p>
      </div>
    </div>
  );
};

export default CardWalletCurrency;
